module.exports = __webpack_public_path__ + "static/media/winSFX.bbc7beac.mp3";